import { gql } from '@apollo/client';

export const GET_HIGH_PROBABILITY_STRIKE_RATE = gql`
  query GetHighProbabilityStrikeRate($analysisTypeId: Int, $minProbability: Int, $timePeriod: String) {
    highProbabilityStrikeRate(analysisTypeId: $analysisTypeId, minProbability: $minProbability, timePeriod: $timePeriod) {
      won
      placed
      resulted
      strikeRate
    }
  }
`;

export const GET_VALUE_SELECTIONS_STRIKE_RATE = gql`
  query GetValueSelectionsStrikeRate($timePeriod: String) {
    valueSelectionsStrikeRate(timePeriod: $timePeriod) {
      won
      placed
      resulted
      strikeRate
    }
  }
`;

export const GET_VALUE_SELECTIONS = gql`
  query GetValueSelections($date: String!, $minMarketOdds: Float, $maxAssessedOdds: Float, $oddsMargin: Float) {
    valueSelections(date: $date, minMarketOdds: $minMarketOdds, maxAssessedOdds: $maxAssessedOdds, oddsMargin: $oddsMargin) {
      adjustedAssessedProb
      horseNumber
      horseName
      odds
      assessedOdds
      analysisSummary
      trackName
      trackCode
      state
      raceNumber
      raceName
      meetingDate
      raceTime
      betType
      betStake
      confidence
      jockey
      trainer
      distance
      raceId
      finishPosition
      resultStatus
      priceSp
      minAssessedOdds
      isConsensusPick
    }
  }
`;

export const GET_HIGH_PROBABILITY_SELECTIONS = gql`
  query GetHighProbabilitySelections($date: String!, $analysisTypeId: Int, $minProbability: Int) {
    highProbabilitySelections(date: $date, analysisTypeId: $analysisTypeId, minProbability: $minProbability) {
      adjustedAssessedProb
      horseNumber
      horseName
      odds
      assessedOdds
      analysisSummary
      trackName
      trackCode
      state
      raceNumber
      raceName
      meetingDate
      raceTime
      betType
      betStake
      confidence
      jockey
      trainer
      distance
      raceId
      finishPosition
      resultStatus
      priceSp
      isConsensusPick
      isStandardClaim
    }
  }
`;
